import { render, staticRenderFns } from "./Sustentable.vue?vue&type=template&id=56e91da1"
import script from "./Sustentable.vue?vue&type=script&lang=js"
export * from "./Sustentable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports